import React from "react";
import "../ChatPage.css";

export default function DisambiguationCard({ data, onSelect, disabled }) {
  if (!data || !data.matches || data.matches.length === 0) return null;

  const isCandidate = data.type === "candidate_disambiguation";
  const isInterviewer = data.type === "interviewer_disambiguation";

  const handleSelect = (item) => {
    if (disabled) return;
    
    // The ID field could be "id", "candidateId", "jobId"
    const selectedId = item.id || item.candidateId || item.jobId;
    
    onSelect({
      selectedId,
      selectedName: item.name || item.candidateName || item.jobTitle || "Unknown",
      pending_action: data.pending_action,
      field: data.field,
      type: data.type
    });
  };

  // Header text based on type
  const headerText = isInterviewer
    ? "Select an interviewer"
    : "Multiple matches found";

  // Icon based on type
  const headerIcon = isInterviewer ? (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="11" cy="11" r="8" />
      <path d="M21 21l-4.35-4.35" />
    </svg>
  );

  return (
    <div className="hn-disambiguation-card">
      <div className="hn-disambiguation-header">
        {headerIcon}
        <span>{headerText}</span>
      </div>
      
      <div className="hn-disambiguation-list">
        {data.matches.map((item, index) => {
          // Extract fields safely
          const name = item.candidateName || item.name || item.jobTitle || item.title || "Unknown";
          let subtitle = "";
          if (isInterviewer) {
            const parts = [item.email, item.designation].filter(Boolean);
            subtitle = parts.join(" · ");
          } else if (isCandidate) {
            // Show multiple fields to help distinguish same-name candidates
            const parts = [
              item.email,
              item.phoneNumber || item.phonenumber,
              item.location || item.address,
              item.experience ? `${item.experience} exp` : null,
              item.candidateId || item.id ? `ID: ${item.candidateId || item.id}` : null,
            ].filter(Boolean);
            subtitle = parts.join(" · ") || "No additional info";
          } else {
            subtitle = item.location || item.jobType || item.experience || "";
          }
            
          return (
            <div key={index} className="hn-disambiguation-item">
              <div className="hn-disambiguation-info">
                <div className="hn-disambiguation-name">{name}</div>
                {subtitle && <div className="hn-disambiguation-subtitle">{subtitle}</div>}
              </div>
              <button 
                className="hn-disambiguation-btn"
                onClick={() => handleSelect(item)}
                disabled={disabled}
              >
                Select
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
